export default class Cookies {
    set(key: string | number, value: string | number | null, days: number) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setDate(date.getDate() + days);
            expires = "; expires=" + date.toUTCString();
        }
        if ("https://" + window.location.hostname === "https://vca.ypc.solutions") {
            document.cookie = key + "=" + (value || "") + expires + "; path=/; secure; sameSite=lax";
        } else {
            document.cookie = key + "=" + (value || "") + expires + "; path=/; secure";
        }

        return true;
    }

    get(key: string | number) {
        let keyEQ = key + "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(keyEQ) === 0) return c.substring(keyEQ.length, c.length);
        }
        return { data: null };
    }

    delete(key: string | number) {
        let date = new Date();

        if (window.location.hostname === "vca.ypc.solutions") {
            document.cookie = key + '=; expires="' + (date.setDate(date.getDate()) - 1000) + '" Max-Age=-99999999; path=/; secure; sameSite=lax';
        } else {
            document.cookie = key + '=; expires="' + (date.setDate(date.getDate()) - 1000) + '" Max-Age=-99999999; path=/; secure';
        }
        return true;
    }
}
